import { useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import { NotificationManager } from 'react-notifications';
import { isAdminSelector } from '../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../components/store/common/slice';
import { useAccessToken } from '../../components/common/hooks/useAccessToken';
import Input from '../../components/common/simple/input';
import { selectCustomStyles } from '../../components/common/shared/select.styled';
import UpArrow from '../../components/images/upload.svg';
import { CreateEditPartnerWrapper } from './CreateEditPartner.styled';
import {fileToBase64} from '../../utils/fileToBase64';

const CreatePartner = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();
    const isAdmin = useSelector(isAdminSelector);

    const [createPartnerValues, setCreatePartnerValues] = useState({
        partnerName: '',
        partnerShortcut: '',
        logo: ''
    });
    const [updatePartnerValues, setUpdatePartnerValues] = useState({
        partnerName: '',
        partnerShortcut: '',
        logo: ''
    });
    const [initialPartnerValues, setInitialPartnerValues] = useState({
        initialPartnerName: '',
        initialPartnerShortcut: '',
        logo: ''
    });
    const [partnersOptions, setPartnersOptions] = useState([]);
    const [currentPartner, setCurrentPartner] = useState({});
    const [createBtnDisabled, setCreateBtnDisabled] = useState(true);
    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(true);

    useEffect(() => {
        if (!client) return;
        (async function () {
            dispatch(showLoader());

            //get data for existing partner and setInitialPartnerValues and setUpdatePartnerValues 

            const { partners } = await client.get('/operations/data/partners');
            const optionsArr = (partners ?? []).map(item => ({
                value: item.partnerID,
                label: `${item.partnerName} - ${item.partnerID}`
            }));
            setPartnersOptions(optionsArr);

            dispatch(hideLoader());
        })();
    }, [client]);

    const onCreatePartnerInputChange = e => {
        const targ = e.target;
        setCreatePartnerValues({
            ...createPartnerValues,
            [targ.name]: targ.value
        });
    };

    const onUpdatePartnerInputChange = e => {
        const targ = e.target;
        setUpdatePartnerValues({
            ...createPartnerValues,
            [targ.name]: targ.value
        });
    };

    const onLogoUpload = async (e, create) => {
        const files = e.target.files;
        let url = create ? 'create' : 'update'
        if (files && files[0]) {
            dispatch(showLoader());
            const imageBase64 = await fileToBase64(files[0]);
            const name = files[0].name;
            const response = await client.put(url, { imageBase64, name });
            if (response.success) {
                NotificationManager.success(t('createPartner.logoUploaded'))
            }
            dispatch(hideLoader());
        }
    };

    useEffect(() => {
        const { partnerName, partnerShortcut } = createPartnerValues;
        if (partnerName.length > 0 && partnerShortcut.length > 0) setCreateBtnDisabled(false);
        else setCreateBtnDisabled(true);
    }, [createPartnerValues]);

    useEffect(() => {
        const { partnerName, partnerShortcut } = updatePartnerValues;
        const { initialPartnerName, initialPartnerShortcut } = initialPartnerValues;

        if (partnerName === initialPartnerName && partnerShortcut === initialPartnerShortcut) setUpdateBtnDisabled(false);
        else setUpdateBtnDisabled(true);
    }, [updatePartnerValues]);

    const sendCreatePartnerData = () => {
        //send data
    };

    const onPartnerDropdownChange = e => setCurrentPartner(e);

    const sendUpdatePartnerData = () => {
        //send data
    };

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <CreateEditPartnerWrapper>
            <div className="row">
                <div className="col-sm editPartnerSection separator">
                    <h4 className='label'>{t('createPartner.titles.update')}</h4>
                    <div>
                        <label className="label">{t('createPartner.labels.select')}</label>
                        <Select
                            styles={selectCustomStyles}
                            options={partnersOptions}
                            value={currentPartner}
                            onChange={onPartnerDropdownChange}
                            name="partnerName"
                        />
                    </div>

                    <Input 
                        label={t('createPartner.labels.name')}
                        name="partnerName" 
                        id="partnerName"
                        value={updatePartnerValues.partnerName}
                        onChange={onUpdatePartnerInputChange}
                    />

                    <Input 
                        label={t('createPartner.labels.shortcut')}
                        name="partnerShortcut" 
                        id="partnerShortcut"
                        value={updatePartnerValues.partnerShortcut}
                        onChange={onUpdatePartnerInputChange}
                    />

                    <div className='upload-wrapper'>
                        <label className='label'>{t('createPartner.labels.logo')}</label>
                        {initialPartnerValues.logo && <img src={initialPartnerValues.logo} alt='logo' />}
                        <button className='file-upload-btn control-with-icon'>
                            {t('createPartner.btns.upload')}
                            <img alt="Upload file" src={UpArrow} />
                            <Form.Control
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf"
                                name={'receipt'}
                                className={'file_upload-input'}
                                onChange={e => onLogoUpload(e, false)}
                            />
                        </button>
                    </div>

                    <button
                        className='bllink-button'
                        disabled={updateBtnDisabled}
                        onClick={sendUpdatePartnerData}
                    >
                        {t('createPartner.btns.update')}
                    </button>
                </div>
                <div className="col-sm editPartnerSection">
                <h4  className='label'>{t('createPartner.titles.create')}</h4>
                    <Input 
                        label={t('createPartner.labels.name')}
                        name="partnerName" 
                        id="partnerName"
                        value={createPartnerValues.partnerName}
                        onChange={onCreatePartnerInputChange}
                    />

                    <Input 
                        label={t('createPartner.labels.shortcut')}
                        name="partnerShortcut" 
                        id="partnerShortcut"
                        value={createPartnerValues.partnerShortcut}
                        onChange={onCreatePartnerInputChange}
                    />

                    <div className='upload-wrapper'>
                        <label className='label'>{t('createPartner.labels.logo')}</label>
                        <button className='file-upload-btn control-with-icon'>
                            {t('createPartner.btns.upload')}
                            <img alt="Upload file" src={UpArrow} />
                            <Form.Control
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf"
                                name={'receipt'}
                                className={'file_upload-input'}
                                onChange={e => onLogoUpload(e, true)}
                            />
                        </button>
                    </div>

                    <button
                        className='bllink-button'
                        disabled={createBtnDisabled}
                        onClick={sendCreatePartnerData}
                    >
                        {t('createPartner.btns.create')}
                    </button>
                </div>
            </div>
        </CreateEditPartnerWrapper>
    );
};

export default CreatePartner;
